import { styled, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import CircleLoader from "../../../components/Loaders/CircleLoader";
import NativeObject from "../../../components/NativeObject/NativeObject";
import TabPanel from "../../../components/TabPanel/TabPanel";

const LayoutWrapper = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});
const ButtonWrapper = styled("div")({
  button: {
    alignItems: "center",
    backgroundColor: "#fff",
    border: "1px solid #e6e6e6",
    borderRadius: "6px",
    display: "flex",
    padding: "8px 12px",
    span: {
      color: "#475257",
      fontSize: "10px",
      fontWeight: "800",
      letterSpacing: "0.15em",
      marginRight: "5px",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
    },
    i: {
      color: "#475257",
      fontSize: "16px",
    },
    "&:hover": {
      backgroundColor: "#f2f4fd",
      span: { color: "#0190d2" },
      i: { color: "#0190d2" },
    },
  },
});

const LoaderWrapper = styled("div")({
  "& img": {
    maxWidth: "18px",
    maxHeight: "16px",
  },
});
function AnalisePdv({ app, config, index }) {
  const [activeTab, setActiveTab] = useState(index);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const { tabs } = config.basketMix.cards[1].modal.analisePdvs;
  const handleSecondTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const exportToXLS = async (position) => {
    setLoadingExcel(false);

    const objectId = tabs[position].id;

    if (app && objectId) {
      setLoadingExcel(true);
      await app.visualization
        .get(objectId)
        .then((vis) => {
          vis.table.exportData({ format: "OOXML", state: "A" }).then((link) => {
            setLoadingExcel(false);
            let newLink = `${process.env.REACT_APP_HOST}${process.env.REACT_APP_PREFIX}${link.substring(link.indexOf("tempcontent"))}`;
            if (!newLink.startsWith('http')) {
              newLink = 'https://' + newLink;
            }
            console.log("Excel download URL:", newLink);
            const a = document.createElement('a');
            a.href = newLink;
            a.download = '';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          });
        })
        .catch(() => setLoadingExcel(false));
    }
  };

  return (
    <LayoutWrapper>
      {/* <FilterMenuModal app={app} filters={config.app?.filters || {}} /> */}
      <div style={{ display: "flex", marginBottom: "24px" }}>
        <Tabs
          value={activeTab}
          onChange={handleSecondTabChange}
          style={{ width: "100%", display: "inline-block" }}
        >
          <Tab
            label={tabs[0].label}
            id={`tab-${1}`}
            aria-controls={`simple-tabpanel-${0}`}
          />
          <Tab
            label={tabs[1].label}
            id={`tab-${2}`}
            aria-controls={`simple-tabpanel-${1}`}
          />
        </Tabs>
        <ButtonWrapper>
          <button type="button" onClick={() => exportToXLS(activeTab)}>
            <span>EXPORTAR PARA EXCEL</span>
            {!loadingExcel ? (
              <i className="far fa-file-export" />
            ) : (
              <LoaderWrapper>
                <CircleLoader />
              </LoaderWrapper>
            )}
          </button>
        </ButtonWrapper>
      </div>
      <TabPanel
        value={activeTab}
        index={0}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeObject
          app={app}
          reference={{ id: tabs[0].id }}
          style={{ flex: 1, height: "100%" }}
          className="analisePDVs"
          type="table"
        />
      </TabPanel>
      <TabPanel
        value={activeTab}
        index={1}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeObject
          app={app}
          reference={{ id: tabs[1].id }}
          style={{ flex: 1, height: "100%" }}
          className="analisePDVs"
          type="table"
        />
      </TabPanel>
    </LayoutWrapper>
  );
}

export default AnalisePdv;

AnalisePdv.defaultProps = {
  app: null,
  config: {},
  index: 0,
};

AnalisePdv.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  index: PropTypes.number,
};
